import { createSlice } from "@reduxjs/toolkit";

const initialState = {
  user: null,
  profile: null,
  loading: true,
};

const authSlice = createSlice({
  name: "auth",
  initialState,
  reducers: {
    setAuthState(state, action) {
      state.user = action.payload.user || null;
      state.profile = action.payload.profile || null;
      state.loading = Boolean(action.payload.loading);
    },
    setLoading(state, action) {
      state.loading = Boolean(action.payload);
    },
    clearAuth(state) {
      state.user = null;
      state.profile = null;
      state.loading = false;
    },
  },
});

export const { setAuthState, setLoading, clearAuth } = authSlice.actions;
export default authSlice.reducer;
